export const INITIAL_DATA = 'INITIAL_DATA'
export const SAVE_DATA_STARTED = 'SAVE_DATA_STARTED'
export const SAVE_DATA_SUCCESS = 'SAVE_DATA_SUCCESS'
export const SAVE_DATA_FAILED = 'SAVE_DATA_FAILED'
